import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { snakSettings } from '../data/proposal';
type IntroStatementProps = {
  onOpenConcept: () => void;
};
export function IntroStatement({
  onOpenConcept
}: IntroStatementProps) {
  return <section aria-labelledby="intro-title" className="max-w-[440px] text-ink" data-id="element-97" data-mp="xy7563a4lyf3">
      <p className="mb-5 text-[15px] leading-snug text-ink" data-id="element-98" data-mp="12w8x7dpj582p">
        This Snak has one job: <span className="text-accent" data-id="element-99" data-mp="owr4wod0zcol">to earn a conversation about what real focus could bring.</span>
      </p>
      <h1 id="intro-title" className="text-[36px] font-semibold leading-[1.02] tracking-[-0.035em] lg:text-[44px]" data-id="element-100" data-mp="txn8f0tgswth">
        An inspiration.
        <br data-id="element-101" data-mp="f1z8hnv6ivve" />
        <span className="text-graphite" data-id="element-102" data-mp="jyfuocitj05u">Not a recommendation.</span>
      </h1>

      <p className="mt-5 text-[16px] leading-relaxed text-graphite" data-id="element-103" data-mp="k0iutpdoq9oa">
        Built from our own research. Ferring hasn’t given us a brief. We took one REKOVELLE strength,{' '}
        <span className="text-ink" data-id="element-104" data-mp="2ec73xax8ji0r">individualized first-cycle dosing based on AMH and body weight</span>, and turned it into a
        40-second experience that HCPs can engage with and remember.
      </p>

      <div className="mt-7 border-t border-ink/10 pt-5" data-id="element-105" data-mp="3vi7ml7zhsq3z">
        <p className="text-[13px] font-semibold text-ink" data-id="element-106" data-mp="e29819luxslf">Where a Snak can work</p>
        <ul className="mt-2.5 flex flex-wrap gap-1.5" data-id="element-107" data-mp="9352csy56czu">
          {snakSettings.map(s => <li key={s} className="rounded-full border border-ink/10 bg-white px-3 py-1 text-[12.5px] text-ink" data-id="element-108" data-mp="3higbpg49vpu7">
              {s}
            </li>)}
        </ul>
        <p className="mt-4 font-mono text-[11px] tracking-[0.16em] text-accent" data-id="element-109" data-mp="3clpzj3vl9ee2">SHORTER · MORE ACTIVE · MORE REWARDING · MORE MEASURABLE</p>
      </div>

      <div className="mt-5 border-t border-ink/10 pt-5" data-id="element-110" data-mp="3mhjf6w4lto02">
        <p className="text-[13px] font-semibold text-ink" data-id="element-111" data-mp="3mk5mcunl21hr">More than one-off campaigns</p>
        <p className="mt-1.5 text-[14px] leading-relaxed text-graphite" data-id="element-112" data-mp="15v8ipgfbaunz">
          We create standalone Snak campaigns, and we run and optimize Snaks across brand portfolios in several countries for
          companies including <span className="text-ink" data-id="element-113" data-mp="3frbrwz6e910">GSK</span> and <span className="text-ink" data-id="element-114" data-mp="3eg61rm66r79">Roche</span>.
        </p>
      </div>

      <div className="mt-7 border-l-2 border-accent pl-4" data-id="element-115" data-mp="8eayhzllfouf">
        <p className="text-[17px] font-medium leading-snug tracking-[-0.01em] text-ink" data-id="element-116" data-mp="8cpz9woc3hq8">
          Let’s find where this could make the biggest difference for Ferring, and build it around your priorities.
        </p>
        <button type="button" onClick={onOpenConcept} className="group mt-3 inline-flex items-center gap-1.5 text-[14px] font-medium text-accent transition-colors duration-150 hover:text-ink focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent" data-id="element-117" data-mp="3gunlmz04k2a7">
          Read the concept
          <ArrowRightIcon size={15} strokeWidth={2} className="transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-118" data-mp="2t4t80f7ze9ow" />
        </button>
      </div>
    </section>;
}